module.exports = __webpack_public_path__ + "static/1359005512.581979ba.jpg";